import {ServerStackIcon} from "@heroicons/react/24/outline";

export const navigation = [
    { name: 'Proxies', href: '#', icon: ServerStackIcon , current: true}
];

export const userNavigation = [
    { name: 'Sign out', href: '#' }
];